export default __webpack_public_path__ + "static/media/Default_pic.78b64d9f.svg";